import { NavLink } from 'react-router-dom';
import tw from 'twin.macro';
import styled from 'styled-components';

export const Tab = styled(NavLink)`
    ${tw`px-2 pt-3 pb-5 mr-px rounded-lg hover:bg-gray-200 hover:bg-opacity-80 bg-gray-100 shadow`}

    &.active-tab {
        ${tw`bg-blue-300`}
    }
`;
export const Tabs = styled.span`
    ${tw`w-full mb-1`}
`;

export const TabView = styled.span`
    ${tw`flex flex-col mt-2`}
`;

export const TabContent = styled.div.attrs(({ padding }) => ({
    className: padding !== 'none' && `p-${padding}`,
    light: true,
}))`
    & {
        ${tw`flex flex-wrap rounded-lg text-black shadow`}
        ${({ color }) => color === 'secondary' ? tw`bg-paper-secondary border-t-2 border-gray-300` : tw`bg-paper`}
        ${({ color }) => color === 'lightBlue' ? tw`border-t-4 border-blue-300` : tw`bg-paper`}
        ${({ padding }) => padding === 'none' && tw`p-0`}
        ${({ padding }) => padding === 'centeredTable' && tw`justify-center flex-col px-48 pt-6 pb-8`}
        ${({ padding }) => !padding && tw`px-8 pt-6 pb-8`}
        ${({ bgColor }) => bgColor && `background-color: ${bgColor};`}
    }
`;